<button class="minimizebutton lower"
    [ngbTooltip]="get_Minimized() ? 'Click to show all information.' : 'Click to show compact information.'"
    [ngClass]="{'fancy-button':get_Minimized()}" (click)="minimize()">
    <i class='bi-arrows-collapse' *ngIf="get_Minimized()"></i>
    <i class='bi-arrows-expand' *ngIf="!get_Minimized()"></i>
</button>
<div id="familiar-height" class="itembox vlist">
    <button class="itembox-close-button list-item center-aligned" (click)="toggleFamiliarMenu()">
        <header class="sectionHeader">Back to Character Sheet</header>
    </button>
    <div class="loading" *ngIf="still_loading()">Loading</div>
    <div class="familiar-box"
        *ngIf="!still_loading() && get_Character().class && get_FamiliarAvailable() && get_FamiliarMenuState()==='in'">
        <!--Desktop-only view-->
        <ng-container *ngIf="!mobile">
            <app-effects [creature]="'Familiar'" [sheetSide]="'center'" id="Familiar-effects"
                class="charactersheet-app charactersheet-row mobile-hide">
            </app-effects>
            <div class="charactersheet-column-container mobile-hide">
                <div class="charactersheet-column">
                    <app-general [creature]="'Familiar'" [sheetSide]="'left'" id="Familiar-general"
                        class="charactersheet-app"></app-general>
                    <app-familiarabilities id="familiarabilities" [sheetSide]="'left'" class="charactersheet-app">
                    </app-familiarabilities>
                    <app-health [creature]="'Familiar'" [sheetSide]="'left'" id="Familiar-health"
                        class="charactersheet-app"></app-health>
                    <app-skills [creature]="'Familiar'" [sheetSide]="'right'" id="Familiar-skills"
                        class="charactersheet-app"></app-skills>
                </div>
                <div class="charactersheet-column">
                    <app-defense [creature]="'Familiar'" [sheetSide]="'right'" id="Familiar-defense"
                        class="charactersheet-app"></app-defense>
                    <app-inventory [creature]="'Familiar'" [sheetSide]="'right'" id="Familiar-inventory"
                        class="charactersheet-app"></app-inventory>
                </div>
            </div>
        </ng-container>
        <!--Mobile-only buttons and views-->
        <ng-container *ngIf="mobile">
            <div class="charactersheet-app charactersheet-row desktop-hide" id="mobile-tabs">
                <button [ngClass]="{'fancy-button':get_ShowMode()===''}" (click)="toggle_Mode('')">
                    <i class="bi-info-circle-fill"></i>
                </button>
                <button [ngClass]="{'fancy-button':get_ShowMode()==='Health'}" (click)="toggle_Mode('Health')">
                    <i class="ra ra-health"></i>
                </button>
                <button [ngClass]="{'fancy-button':get_ShowMode()==='Defense'}" (click)="toggle_Mode('Defense')">
                    <i class="ra ra-shield"></i>
                </button>
                <button [ngClass]="{'fancy-button':get_ShowMode()==='Skills'}" (click)="toggle_Mode('Skills')">
                    <i class="ra ra-muscle-up"></i>
                </button>
                <button [ngClass]="{'fancy-button':get_ShowMode()==='Actions'}" (click)="toggle_Mode('Actions')">
                    <app-actionIcons [actionString]="'1A'" style="margin:.12rem -.16rem -.14rem -.16rem">
                    </app-actionIcons>
                </button>
                <button [ngClass]="{'fancy-button':get_ShowMode()==='ConditionsEffects'}"
                    (click)="toggle_Mode('ConditionsEffects')">
                    <i class="ra ra-lightning-bolt"></i>
                </button>
            </div>
            <ng-container *ngIf="!still_loading()">
                <div class="charactersheet-column-container desktop-hide">
                    <div class="charactersheet-column">
                        <app-general id="Character-general" class="charactersheet-app" [creature]="'Familiar'"
                            [sheetSide]="'center'" [ngClass]="{'minimized':(get_Minimized())}"
                            *ngIf="!get_ShowMode() || !['Health','Defense','Attacks','Spells','Skills','Actions','Inventory','ConditionsEffects'].includes(get_ShowMode())">
                        </app-general>
                        <app-familiarabilities id="familiarabilities" [sheetSide]="'center'" class="charactersheet-app"
                            *ngIf="!get_ShowMode()">
                        </app-familiarabilities>
                        <app-health id="Character-health" class="charactersheet-app" [creature]="'Familiar'"
                            [sheetSide]="'center'" [showMinimizeButton]="(get_ShowMode() !== 'Downtime')"
                            [ngClass]="{'minimized':(get_Minimized() || (get_ShowMode() === 'Downtime'))}"
                            *ngIf="get_ShowMode()==='Health'">
                        </app-health>
                        <app-defense id="Character-defense" class="charactersheet-app" [creature]="'Familiar'"
                            [sheetSide]="'center'" [ngClass]="{'minimized':(get_Minimized())}"
                            *ngIf="get_ShowMode()==='Defense'">
                        </app-defense>
                        <app-skills id="Character-skills" class="charactersheet-app" [creature]="'Familiar'"
                            [sheetSide]="'center'" [ngClass]="{'minimized':(get_Minimized())}"
                            *ngIf="get_ShowMode()==='Skills'">
                        </app-skills>
                        <app-activities id="Character-activities" class="charactersheet-app" [creature]="'Familiar'"
                            [sheetSide]="'center'" [ngClass]="{'minimized':(get_Minimized())}"
                            *ngIf="get_ShowMode()==='Actions'">
                        </app-activities>
                        <app-effects id="Character-effects" class="charactersheet-app" [creature]="'Familiar'"
                            [fullDisplay]="true" [sheetSide]="'center'" *ngIf="get_ShowMode()==='ConditionsEffects'">
                        </app-effects>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>